import { render } from "./ActivityCodeFormPopup.vue?vue&type=template&id=2c19d063&ts=true"
import script from "./ActivityCodeFormPopup.vue?vue&type=script&lang=ts"
export * from "./ActivityCodeFormPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__